import { z } from "zod";

import { integerFieldSchema } from "@/utils/common-zod-schemas";
import { ReplayTypeEnum } from "@classview/shared-types";

const addonsSchema = z.object({
  concurrency: integerFieldSchema("Concurrency"),
  replay: z.nativeEnum(ReplayTypeEnum),
  isGivenEventAccess: z.boolean().optional(),
  storageInGB: integerFieldSchema("Storage"),
  storageDurationInDays: integerFieldSchema("Storage Duration"),
});
type AddonsFormData = z.infer<typeof addonsSchema>;

const organisationLicensingSchema = z.object({
  licenseId: z.string().min(1, { message: "Pricing plan is required" }),
  licenseEndDate: z.date(),
});
type OrganisationLicensingFormData = z.infer<
  typeof organisationLicensingSchema
>;

export { addonsSchema, organisationLicensingSchema };
export type { AddonsFormData, OrganisationLicensingFormData };
